/* eslint-disable no-restricted-syntax -- loader width/height are prop-driven */
import type { PixelValueType } from "@UI/types/layout.ts";
import type { FC } from "react";

interface Props {
  width?: PixelValueType;
  height?: PixelValueType;
  color?: "light" | "primary";
}

const DCircleLoader: FC<Props> = ({
  width = "20px",
  height = "20px",
  color = "primary",
}) => {
  return (
    <svg
      className="d-loader"
      style={{
        width,
        height,
      }}
      viewBox="25 25 50 50"
    >
      <circle
        className={`d-loader__path d-stroke-${color}`}
        cx="50"
        cy="50"
        r="20"
      />
    </svg>
  );
};

export default DCircleLoader;
